<div class="register-wrapper">
  <div class="stars-bg"></div>
  <div class="stars-fg"></div>

  <div class="register-container card-glass p-5 shadow-lg">
    <h2 class="text-center text-white mb-4 animate-fade-in-glow">
      Join Stranger Chat
    </h2>

    <form (ngSubmit)="onRegister()" #registerForm="ngForm">
      <div class="form-floating mb-3 animate-float-in delay-1">
        <input type="text" class="form-control bg-dark text-white border-0 shadow-sm" id="originalName"
          name="originalName" placeholder="originalName" [(ngModel)]="form.originalName" required />
        <label for="originalName">Original Name</label>
      </div>
      <div class="form-floating mb-3 animate-float-in delay-1">
        <input type="text" class="form-control bg-dark text-white border-0 shadow-sm" id="username" name="username"
          placeholder="Username" [(ngModel)]="form.username" required />
        <label for="username">Username</label>
      </div>
<!-- 
      <div class="form-floating mb-3 animate-float-in delay-2">
        <input type="email" class="form-control bg-dark text-white border-0 shadow-sm" id="email" name="email"
          placeholder="Email" [(ngModel)]="form.email" required />
        <label for="email">Email</label>
      </div> -->

      <div class="form-floating mb-3 animate-float-in delay-3">
        <input type="password" class="form-control bg-dark text-white border-0 shadow-sm" id="password" name="password"
          placeholder="Password" [(ngModel)]="form.password" required />
        <label for="password">Password</label>
      </div>

      <div class="form-floating mb-3 animate-float-in delay-4">
        <select class="form-select bg-dark text-white border-0 shadow-sm" id="gender" name="gender"
          [(ngModel)]="form.gender" required>
          <option selected disabled value="">Choose Gender</option>
          <option value="male">Male 🚹</option>
          <option value="female">Female 🚺</option>
          <option value="other">Other ⚧️</option>
        </select>
        <label for="gender">Gender</label>
      </div>

      <div class="d-grid gap-2 mt-4 animate-float-in delay-5">
        <button type="submit" class="btn btn-neon py-2">
          Register
        </button>
        <button type="button" class="btn btn-outline-light py-2" (click)="login()">
          Already have an account?
        </button>
      </div>
    </form>
  </div>
</div>

<!-- OTP Modal -->
<!-- @if (showOtpModal) {
<div class="otp-modal">
  <div class="otp-modal-content card-glass p-4 shadow-lg animate-fade-in-glow">
    <h4 class="text-white mb-3 text-center">Enter OTP</h4>
    <input type="text" maxlength="6" [(ngModel)]="otp"
      class="form-control text-center bg-dark text-white border-0 shadow-sm mb-3" placeholder="6-digit OTP" />
    <div class="d-grid">
      <button class="btn btn-neon" (click)="submitOtp()">Submit</button>
    </div>
  </div>
</div>
} -->

<app-spinner [show]="spinner" [message]="spinMessage" />